// extracted by mini-css-extract-plugin
export default {"rating":"dD-z","numberOfStars":"eD-z","count":"fD-z","barGraphSpacing":"gD-z","barGraph":"hD-z"};